import React, { useMemo, useState, useEffect } from "react";
import { Button, Card, CardHeader, Form } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

// Formik validation
import { useForm } from "react-hook-form";
import { Table, TableRow } from "../../../components/Table";
import {
  TRA_FILTER,
  TRA_PAGINATION_OPTIONS,
  WEBHOOK_EVENTS_LOCAL,
} from "../../../constant";
import {
  getLocalData,
  responseToaster,
  setLocalData,
} from "../../../helperFunctions";
import ControlledInput from "../../../components/Custom/Forms/Controller/ControlledInput";
import { useRole } from "../../../redux/slices/authSlice";
import { getWebhookStatus, useWebhookStatus } from "../../../redux/slices/webhookStatusSlice";
import ViewResDataModal from "../../../components/Custom/Modals/ViewResDataModal/ViewResDataModal";

const WebhookStatus = () => {
  const initialValues = {
    searchData: "",
  };

  const [filterColumns, setFilterColumns] = useState([]);
  const [filter, setFilter] = useState(TRA_FILTER);
  const [data, setData] = useState({});
  const { isLoading } = useSelector((state) => state.webHookStatus);
  const webhookStatusStats = useWebhookStatus();

  const parseDate = (dateStr) => {
    // "28-11-2025 21:50:05"
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    return new Date(`${year}-${month}-${day} ${timePart}`);
  };

  const sortedData = useMemo(() => {
    return (
      webhookStatusStats?.data
        ?.slice()
        .sort(
          (a, b) =>
            parseDate(b.createdAt) - parseDate(a.createdAt)
        ) || []
    );
  }, [webhookStatusStats?.data]);


  const dispatch = useDispatch();
  const [isViewsendDataModal, setIsViewsendDataModal] = useState(false);
  const role = useRole("Webhook Status");

  const onCloseModal = () => {
    setData({ ...data });
    setIsViewsendDataModal(!isViewsendDataModal);
  };
  const columns = useMemo(
    () => [
      {
        title: "ID",
        name: "id",
      },
      {
        title: "PG Name",
        name: "pgName",
      },
      {
        title: "IP Info",
        name: "ipInfo",
      },
      {
        title: "DATE",
        name: "createdAt",
      },
      {
        title: "Action",
        name: "",
        Cell: (data) => {
          return (
            <>
              <Button
                color="primary"
                className="btn-smallsize"
                style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
                onClick={() => {
                  setData({ ...data })
                  setIsViewsendDataModal(!isViewsendDataModal);
                }
                }
              >
                View Res Data
              </Button >
            </>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("webhookStatus-list")) {
      GetWebhook();
    }
  }, [filter]);

  const onSubmit = async () => {
    const values = getValues();
    setFilter({
      ...filter,
      ...values,
      ...TRA_FILTER,
      isFilter: true,
    });
  };
  const { control, handleSubmit, getValues, reset } = useForm({
    defaultValues: initialValues,
  });

  const GetWebhook = async () => {
    try {
      const {
        isFilter,
        page_no,
        limit,
        searchData,
      } = filter;
      const payload =
      {
        filter_data: {
          searchData
        },
        page_no,
        limit,
      }

      const res = await dispatch(getWebhookStatus(payload)).unwrap();
      if (isFilter) {
        responseToaster(res);
      }
    } catch (err) { }
  };

  const [isFilterOpen, setIsFilterOpen] = useState(
    getLocalData(WEBHOOK_EVENTS_LOCAL, false)
  );
  const toggleIsFilterOpen = () => {
    setIsFilterOpen(!isFilterOpen);
    setLocalData(WEBHOOK_EVENTS_LOCAL, !isFilterOpen);
  };

  return (
    <>
      {role.includes("webhookStatus-list") ? (
        <>
          <div className="webhook_event-main-div">
            <Card>
              <CardHeader className="flex-column  align-items-start">
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <h4 className="main-title">
                    <b>Webhook Status</b>
                  </h4>

                  <div className="d-flex">
                    <Button
                      type="button"
                      className="filterbtn"
                      onClick={toggleIsFilterOpen}
                    >
                      <i className="fa-solid fa-filter"></i> Apply Filter
                    </Button>
                  </div>
                </div>
                <Form
                  className="d-flex my-xl-auto right-content align-items-end button-space"
                  style={{ flexWrap: "wrap" }}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {isFilterOpen && (
                    <>
                      <ControlledInput
                        placeholder="Enter Search Value"
                        name="searchData"
                        label="Search"
                        control={control}
                      />
                      <Button type="submit" color="primary">
                        Apply
                      </Button>
                      <Button
                        color="danger "
                        onClick={() => {
                          reset();
                          setFilter({ ...TRA_FILTER });
                        }}
                      >
                        Clear
                      </Button>
                    </>
                  )}
                </Form>
              </CardHeader>
              <Table
                columns={columns}
                isLoading={isLoading}
                data={sortedData}
                isData={!!sortedData?.length}
                filterColumns={filterColumns}
                count={webhookStatusStats?.total_item || 0}
                pagination={filter}
                isExpandable={false}
                handlePaginationChange={(pagination) => {
                  setFilter({
                    ...filter,
                    ...pagination,
                  });
                }}
                onColumnsChange={(columns) => {
                  setFilterColumns(columns);
                }}
                paginationOptions={TRA_PAGINATION_OPTIONS}
              >
                {sortedData?.map((item) => {
                  return (
                    <TableRow
                      isExpandable={false}
                      columns={columns}
                      item={item}
                      filterColumns={filterColumns}
                    />
                  );
                })}
              </Table>
            </Card>

            <ViewResDataModal
              data={data}
              isViewsendDataModal={isViewsendDataModal}
              onCloseModal={() => onCloseModal()}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default WebhookStatus;
